import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';


export enum SweetAlertIcon {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Question = 'question'
}


@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  constructor(private translateService: TranslateService) { }

  confirmDelete(message?: string) {
    return Swal.fire({
      title: 'هل انت متأكد؟',
      text: message ?? "لن تستطع التراجع عن هذا!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'لا',
      confirmButtonText: 'نعم!'
    })
  }

  confirm(title: string, message: string, icon: SweetAlertIcon, confirmTitle: string, denyTitle?: string) {
    return Swal.fire({
      title: title,
      text: message,
      icon: icon,
      showCancelButton: !!denyTitle,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: denyTitle,
      confirmButtonText: confirmTitle
    })
  }

  success(message: string, timer?: number) {
    return Swal.fire({
      title: this.translateService.instant('نجاح'),
      icon: SweetAlertIcon.Success,
      html: message,
      timer: timer ?? 2000,
      timerProgressBar: true,
      didOpen: () => {
        // Swal.showLoading()
        // const b = Swal.getHtmlContainer().querySelector('b')
        // timerInterval = setInterval(() => {
        //   b.textContent = Swal.getTimerLeft()
        // }, 100)
      },
      willClose: () => {
      }
    })
  }

  warning(title: string, message?: string) {
    Swal.fire({
      title: title,
      text: message,
      icon: SweetAlertIcon.Warning,
      confirmButtonColor: '#3CBACB',
      confirmButtonText: 'حسناً'
    });
  }

  error(message: string) {
    Swal.fire(this.translateService.instant('خطأ'), message, SweetAlertIcon.Error);
  }

  showServiceDownWarning(): void {
    Swal.fire({
      title: 'تنبيه / Notice',
      icon: 'info',
      html: `
        <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                    text-align: center;
                    direction: rtl;
                    line-height: 1.6;
                    padding: 0 20px;
                    max-width: 100%;">

          <!-- Logo -->
         <!--
         <img src="http://www.gafi.gov.eg/Style%20Library/linkdevCustomImg/images/logo-1.png"
               alt="شعار الهيئة العامة للاستثمار والمناطق الحرة"
               style="max-width: 180px; margin: 0 auto 20px; display: block;">
               -->

          <!-- Authority Name - Bigger width popup + RED color -->
          <h2 style="margin: 0 0 20px; font-size: 1.5rem; font-weight: bold; color: #c8102e;">
            الهيئة العامة للاستثمار والمناطق الحرة
          </h2>

          <!-- Arabic part -->
          <h3 style="margin: 12px 0 8px; font-size: 1.2rem; font-weight: 600;">
            السادة العملاء
          </h3>
          <p style="margin: 0 0 24px; font-size: 1.1rem;">
          لضمان جودة تقديم الخدمة ، يرجى العلم أن الخدمة متاحة طيلة أيام الأسبوع فيما عدا يومي الجمعة والسبت وكذلك الأجازات والعطلات الرسمية.
        </p>

          <!-- Separator -->
          <hr style="border: 0; border-top: 1px solid #ccc; margin: 24px 0;">

          <!-- English part -->
          <h3 style="margin: 12px 0 8px; font-size: 1.2rem; font-weight: 600;">
            Dear Customers
          </h3>
          <p style="margin: 0; font-size: 1.1rem;">
            To ensure quality service, please note that the service is currently unavailable.<br>
            It is available all days of the week, except Fridays and Saturdays, as well as official holidays.
          </p>
        </div>
      `,
      confirmButtonText: 'حسناً / OK',
      confirmButtonColor: '#3CBACB',
      allowOutsideClick: true,
      allowEscapeKey: true,
      showCloseButton: true,
      width: '620px',
      customClass: {
        popup: 'service-notice-popup',
      },
    });
  }
}
